import { z } from 'zod';

import { defineQuery } from '@nesso/common-contracts/define';

export const GET_PASSWORD_STATUS_TYPE = 'user/get-password-status';
export const GET_PASSWORD_RESET_TOKEN_STATUS_TYPE = 'user/get-password-reset-token-status';

export const getPasswordStatus = defineQuery(
    GET_PASSWORD_STATUS_TYPE,
    z.object({
        email: z.email(),
    }),
    z.object({
        email: z.email(),
        hasPassword: z.boolean(),
        provider: z.enum(['google', 'native']),
        passwordUpdatedAt: z.iso.datetime().optional(),
    }),
);

export const getPasswordResetTokenStatus = defineQuery(
    GET_PASSWORD_RESET_TOKEN_STATUS_TYPE,
    z.object({
        token: z.string().min(1),
    }),
    z.object({
        valid: z.boolean(),
    }),
);
